<a [id]="id" [routerLink]="['']">
  <span class="sr-only">Strona główna</span>
  <img class="app-logo" [src]="url" [alt]="'global.logo' | trans" />
</a>
